if (!customElements.get('deferred-video-component')) {
  
  class DeferredVideo extends HTMLElement {
    constructor() {
      super();
      this.videoElement = null;
      this.hasInitialized = false;
      this.observer = null;
      this.observerTarget = null;
      this.videoListenersAttached = false;
      this.dataset.videoVisibility = 'not-observing';
      this.dataset.videoState = 'idle';
    }

    connectedCallback() {
      this.autoStop = this.dataset.autoStop !== 'false';
      this.dataset.videoAutoStop = `${this.autoStop}`;

      const options = {
        root: null, 
        threshold: 0 
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          this.dataset.videoIntersectionRatio = `${entry.intersectionRatio}`;
          if (entry.isIntersecting) {
            this.dataset.videoVisibility = 'in-view';
            this.handleInView();
          } else {
            this.dataset.videoVisibility = 'out-of-view';
            this.handleOutOfView();
          }
        });
      }, options);

      this.observerTarget = this.closest('.card-disrupter__video-wrapper') || this;
      this.dataset.videoObserverTarget = this.observerTarget === this ? 'self' : 'wrapper';
      this.observer.observe(this.observerTarget);
    }

    handleInView() {
      if (!this.hasInitialized) {
        const template = this.querySelector('template');
        const image = this.querySelector('.image');
        
        if (template) {
          const content = template.content.cloneNode(true);
          this.appendChild(content);
          
          this.videoElement = this.querySelector('video');
          this.attachVideoDebugListeners();
          
          template.remove();
          if (image) image.remove();
          this.hasInitialized = true;
        }
      }

      if (this.videoElement && this.videoElement.paused) {
        this.dataset.videoState = 'play-requested';
        const playPromise = this.videoElement.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            this.dataset.videoState = 'autoplay-prevented';
            console.warn("Autoplay was prevented:", error);
          });
        }
      }
    }

    handleOutOfView() {
      if (!this.autoStop) {
        this.dataset.videoState = 'autostop-disabled';
        return;
      }

      if (this.videoElement && !this.videoElement.paused) {
        this.dataset.videoState = 'pause-requested';
        this.videoElement.pause();
      }
    }

    attachVideoDebugListeners() {
      if (!this.videoElement || this.videoListenersAttached) return;

      this.videoElement.addEventListener('play', () => {
        this.dataset.videoState = 'playing';
      });
      this.videoElement.addEventListener('pause', () => {
        this.dataset.videoState = 'paused';
      });
      this.videoElement.addEventListener('ended', () => {
        this.dataset.videoState = 'ended';
      });
      this.videoElement.addEventListener('waiting', () => {
        this.dataset.videoState = 'buffering';
      });

      this.videoListenersAttached = true;
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('deferred-video', DeferredVideo);
}